// src/lib/utils/fakeData.js

export const fakeChatData = [
    {
        id: 1,
        sender: "ai",
        content: "您好，我是您的AI运营助理四加。我给您介绍一下我目前的功能：首先您需要在左上角选择您对应的平台，然后下方会列出一个运营流程的引导，点击引导我会帮您列出对应常见情况。"
    },
    // {
    //     id: 3,
    //     sender: "user",
    //     content: "你能帮我写一份产品推广文案吗？"
    // },
    // {
    //     id: 4,
    //     sender: "ai",
    //     content: "当然可以！请告诉我你的产品名称和主要卖点。"
    // },
    // {
    //     id: 5,
    //     sender: "user",
    //     content: "产品名是“智能水杯”，可以自动检测水温并提醒喝水。"
    // },
    // {
    //     id: 6,
    //     sender: "ai",
    //     content: "好的，以下是一份推广文案：\n\n“智能水杯，您的贴心健康管家！自动检测水温，智能提醒喝水，让健康饮水变得更简单。快来体验科技带来的贴心关怀吧！”"
    // },
    // // 新增对话
    // {
    //     id: 7,
    //     sender: "user",
    //     content: "你会讲笑话吗？"
    // },
    // {
    //     id: 8,
    //     sender: "ai",
    //     content: "当然会！你想听冷笑话还是脑筋急转弯？"
    // },
    // {
    //     id: 9,
    //     sender: "user",
    //     content: "来个冷笑话吧。"
    // },
    // {
    //     id: 10,
    //     sender: "ai",
    //     content: "好的：为什么鱼不说话？因为水里有话（化）学成分。"
    // },
    // {
    //     id: 11,
    //     sender: "user",
    //     content: "帮我查一下明天天气。"
    // },
    // {
    //     id: 12,
    //     sender: "ai",
    //     content: "请问你在哪个城市？"
    // },
    // {
    //     id: 13,
    //     sender: "user",
    //     content: "成都。"
    // },
    // {
    //     id: 14,
    //     sender: "ai",
    //     content: "明天成都多云，气温18~25℃，适合出行。"
    // }
];